module.exports = __webpack_public_path__ + "static/media/29EUNOG9.c3ecc556.jpg";